// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3852fa0a","732":"75a25fc1","977":"96d15e16"}[chunkId] + ".chunk.js";
};